import { createReducer } from '@reduxjs/toolkit';
import { AsyncStatus } from 'lib-shared-legacy-types';

import { busylightActions } from './busylight.actions';

const {
  stop,
  stopFulfilled,
  stopRejected,
  getConnectedStatus,
  getConnectedStatusFulfilled,
  getConnectedStatusRejected,
} = busylightActions;

export type BusylightState = {
  meta: {
    status: AsyncStatus;
    stop: AsyncStatus;
  };
  isConnectedToBusylight: boolean;
};

const initialState: BusylightState = {
  meta: {
    status: 'succeeded',
    stop: 'succeeded',
  },
  isConnectedToBusylight: false,
};

export const busylightReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(stop, (state) => {
      state.meta.stop = 'loading';
    })
    .addCase(stopFulfilled, (state) => {
      state.meta.stop = 'succeeded';
    })
    .addCase(stopRejected, (state) => {
      state.meta.stop = 'failed';
    })
    .addCase(getConnectedStatus, (state) => {
      state.meta.status = 'loading';
    })
    .addCase(getConnectedStatusFulfilled, (state, action) => {
      state.meta.status = 'succeeded';
      state.isConnectedToBusylight =
        action.payload && action.payload.connected !== undefined
          ? action.payload.connected
          : state.isConnectedToBusylight;
    })
    .addCase(getConnectedStatusRejected, (state) => {
      state.meta.status = 'failed';
    });
});
